import { render, staticRenderFns } from "./OtpFullModal.vue?vue&type=template&id=42896488&scoped=true&lang=pug&"
import script from "./OtpFullModal.vue?vue&type=script&lang=js&"
export * from "./OtpFullModal.vue?vue&type=script&lang=js&"
import style0 from "./OtpFullModal.vue?vue&type=style&index=0&id=42896488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42896488",
  null
  
)

export default component.exports